module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"CreateSuccess":"La boîte de réception a bien été créée"}}')
  delete Component.options._Ctor
}
